export default function updateSavedInventoryItemActionCreator(savedInventoryDuck, personalization) {
  return function (data, onSuccess) {
    if (onSuccess === void 0) {
      onSuccess = () => {};
    }
    return async (dispatch, getState) => {
      const {
        updateSavedInventory
      } = typeof getState().toJS === 'function' ? getState().get('savedInventory') : getState().savedInventory;
      let overwrite = false;

      // Only current warning is to alert user that a saved title exists
      // if there is an existing warning then we have to assume that user has seen the warning and wants to overwrite
      // If not then we leave overwrite as false as they are attempting another name and we need to go through the process again
      const isOverwritable = updateSavedInventory.messages && updateSavedInventory.messages.warning;
      if (isOverwritable) {
        overwrite = true;
      }

      // set loading animate button

      dispatch({
        type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
        payload: 'loading'
      });
      try {
        const actionResponse = await personalization.updateSavedInventoryItem({
          ...data,
          overwrite
        });
        if (actionResponse.messages) {
          dispatch(savedInventoryDuck.creators.setUpdateSavedInventoryState({
            messages: actionResponse.messages
          }));
        } else {
          if (actionResponse?.bookmark?.version) {
            dispatch(savedInventoryDuck.creators.updateSavedInventory({
              id: data.bookmark.id,
              version: actionResponse.bookmark.version
            }));
          }
          onSuccess({
            ...actionResponse,
            ...data
          });
          // set loading animate button
          dispatch({
            type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
            payload: 'loaded'
          });
          setTimeout(() => {
            dispatch({
              type: savedInventoryDuck.types.HIDE_UPDATE_SAVED_INVENTORY
            });
            // set loading animate button
            dispatch({
              type: savedInventoryDuck.types.SET_ANIMATED_BUTTON_STATE,
              payload: ''
            });
          }, 3000);
        }
        return actionResponse;
      } catch (error) {
        throw Error(error);
      }
    };
  };
}